import { render } from "./VariablesRadiativas.vue?vue&type=template&id=47081cd2&scoped=true"
import script from "./VariablesRadiativas.vue?vue&type=script&lang=js"
export * from "./VariablesRadiativas.vue?vue&type=script&lang=js"

import "./VariablesRadiativas.vue?vue&type=style&index=0&id=47081cd2&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47081cd2"]])

export default __exports__